import { connect } from 'react-redux'

import {
  getInvoices,
  updateQs,
  setSort,
  openFilter,
  setCheckedFilterStatus,
  removeCheckedFilterStatus,
  setCheckedFilterType,
  removeCheckedFilterType,
  setCheckedFilterCountry,
  removeCheckedFilterCountry,
  setCheckedFilterPaymentMethod,
  removeCheckedFilterPaymentMethod,
} from 'reduxpath/ducks/ZotapayInvoices/List'

import Table from './units'

const mapStateToProps = (state, ownProps) => ({
  tab: ownProps.tab,
  invoices: state.ZotapayInvoices.invoices,
  invoiceStatus: state.ZotapayInvoices.invoiceStatus,
  qs: state.ZotapayInvoices.qs,
  sort: state.ZotapayInvoices.sort,
  openFilterStatus: state.ZotapayInvoices.openFilterStatus,
  openFilterType: state.ZotapayInvoices.openFilterType,
  openFilterCountry: state.ZotapayInvoices.openFilterCountry,
  openFilterPaymentMethod: state.ZotapayInvoices.openFilterPaymentMethod,
  countries: state.Reference.countries.rows,
  checkedFilterStatus: state.ZotapayInvoices.checkedFilterStatus,
  checkedFilterType: state.ZotapayInvoices.checkedFilterType,
  checkedFilterCountry: state.ZotapayInvoices.checkedFilterCountry,
  checkedFilterPaymentMethod: state.ZotapayInvoices.checkedFilterPaymentMethod,
  debouncing: state.ZotapayInvoices.debouncing,
})

const mapDispatchToProps = dispatch => ({
  handlePageChange(qs) {
    return key => {
      const limit = 10
      const newQs = {
        ...qs,
        skip: key.selected * limit,
      }

      dispatch(getInvoices(newQs))
      dispatch(updateQs(newQs))
    }
  },
  handleSort(sort, qs) {
    return field => {
      const newQs = {
        ...qs,
        sort: `${field} ${sort}`,
      }
      dispatch(
        getInvoices(newQs, () => {
          dispatch(setSort(sort === 'DESC' ? 'ASC' : 'DESC'))
          dispatch(updateQs(newQs))
        })
      )
    }
  },
  handleOpenFilter(
    openFilterStatusParam,
    openFilterTypeParam,
    openFilterCountry,
    openFilterPaymentMethod
  ) {
    return filter => {
      const param = {
        status: openFilterStatusParam,
        type: openFilterTypeParam,
        country: openFilterCountry,
        payment: openFilterPaymentMethod,
      }
      dispatch(openFilter(!param[filter], filter))
    }
  },
  handleOnCheck(
    invoiceStatus,
    qs,
    debouncing,
    checkedFilterStatus,
    checkedFilterType,
    checkedFilterCountry,
    checkedFilterPaymentMethod,
    countries
  ) {
    return (event, value, filter) => {
      let updateCheckedFilterStatus = [...checkedFilterStatus]
      let updateCheckedFilterType = [...checkedFilterType]
      let updateCheckedFilterCountry = [...checkedFilterCountry]
      let updateCheckedFilterPaymentMethod = [...checkedFilterPaymentMethod]
      const isChecked = event.target.checked
      const payload = {
        isChecked,
        value,
        filter,
      }

      // -- Condition for checking, set and remove filter -- //
      switch (filter) {
        case 'status':
          if (isChecked) {
            updateCheckedFilterStatus = [...checkedFilterStatus, value]
            dispatch(setCheckedFilterStatus(payload))
          } else {
            updateCheckedFilterStatus = checkedFilterStatus.filter(data => data !== value)
            dispatch(removeCheckedFilterStatus(payload))
          }
          break
        case 'type':
          if (isChecked) {
            updateCheckedFilterType = [...checkedFilterType, value]
            dispatch(setCheckedFilterType(payload))
          } else {
            updateCheckedFilterType = checkedFilterType.filter(data => data !== value)
            dispatch(removeCheckedFilterType(payload))
          }
          break
        case 'payment':
          if (isChecked) {
            updateCheckedFilterPaymentMethod = [...checkedFilterPaymentMethod, value]
            dispatch(setCheckedFilterPaymentMethod(payload))
          } else {
            updateCheckedFilterPaymentMethod = checkedFilterPaymentMethod.filter(
              data => data !== value
            )
            dispatch(removeCheckedFilterPaymentMethod(payload))
          }
          break
        default:
          if (isChecked) {
            updateCheckedFilterCountry = [...checkedFilterCountry, value]
            dispatch(setCheckedFilterCountry(payload))
          } else {
            updateCheckedFilterCountry = checkedFilterCountry.filter(
              data => data !== value
            )
            dispatch(removeCheckedFilterCountry(payload))
          }
          break
      }

      const newQs = {
        ...qs,
        skip: 0,
        where: {
          ...qs.where,
          // -- To cater query pairs and the value is numbers with new assigned query search -- //
          or: updateCheckedFilterStatus.map(data => ({
            status: data ? invoiceStatus[data].status : '',
          })),
          // -- query pairs if the value !== numbers with new assigned query search -- //
          invoiceType: updateCheckedFilterType,
          paymentMethod: updateCheckedFilterPaymentMethod,
          country: updateCheckedFilterCountry.map(
            data => countries.filter(countryData => countryData.code === data)[0].id
          ),
        },
      }
      debouncing(() => {
        dispatch(getInvoices(newQs))
        dispatch(updateQs(newQs))
      })
    }
  },
})

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  handleSort: dispatchProps.handleSort(stateProps.sort, stateProps.qs),
  handleOpenFilter: dispatchProps.handleOpenFilter(
    stateProps.openFilterStatus,
    stateProps.openFilterType,
    stateProps.openFilterCountry,
    stateProps.openFilterPaymentMethod
  ),
  handleOnCheck: dispatchProps.handleOnCheck(
    stateProps.invoiceStatus,
    stateProps.qs,
    stateProps.debouncing,
    stateProps.checkedFilterStatus,
    stateProps.checkedFilterType,
    stateProps.checkedFilterCountry,
    stateProps.checkedFilterPaymentMethod,
    stateProps.countries
  ),
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Table)
